import { PaginationParams, PaginationParamsCamelCase } from '@x/types';
import {
  ApiMutationConfig,
  ApiQueryConfig,
  Organization,
  OrgsResponse,
} from 'api/types';
import { createApiEndpoint } from 'api/utils';
import { URLS } from 'config';
import { PostSubscriberConfig } from './types';

type GetSubscribersConfig = ApiQueryConfig<
  OrgsResponse,
  unknown,
  PaginationParams | PaginationParamsCamelCase
>;

type GetOrganizationsConfig = ApiQueryConfig<Organization[]>;

type AddServiceBody = {
  organizationId: number;
  serviceId: number;
};

type AddServiceResponse = {
  ServiceName: string;
  ServiceConfigId: number;
};

type PostServiceConfig = ApiMutationConfig<
  AddServiceBody,
  unknown,
  AddServiceResponse
>;

const url = `${URLS.app}/api/Organizations`;

export const getSubscribers = createApiEndpoint<GetSubscribersConfig>({
  method: 'POST',
  url: `${url}/Subscribers`,
});

export const getSubscribersList = createApiEndpoint<GetOrganizationsConfig>({
  method: 'GET',
  url: `${url}/List`,
});

export const addSubscriber = createApiEndpoint<PostSubscriberConfig>({
  method: 'POST',
  url: `${url}/Post`,
});

export const addSubscriberService = createApiEndpoint<PostServiceConfig>({
  method: 'POST',
  url: `${url}/AddService`,
});
